import * as Sentry from "@sentry/react";
import type { ErrorInfo } from "react";
import type { HydrationOptions } from "react-dom/client";
import { z } from "zod";

const reportedErrorIds = new WeakMap<object, string>();
const weakKeySchema = z.custom<object>((value) => Object(value) === value);
const captureReactError = Sentry.reactErrorHandler((cause, _info, eventId) => {
  const weakKey = weakKeySchema.safeParse(cause);
  if (weakKey.success) reportedErrorIds.set(weakKey.data, eventId);
});

export function reportReactError(cause: unknown, errorInfo: ErrorInfo) {
  const weakKey = weakKeySchema.safeParse(cause);
  const eventId = weakKey.success
    ? reportedErrorIds.get(weakKey.data)
    : undefined;
  if (eventId) return eventId;

  captureReactError(cause, errorInfo);
  return weakKey.success ? reportedErrorIds.get(weakKey.data) : undefined;
}

export const sentryReactErrorHandlers = {
  onCaughtError: reportReactError,
  onUncaughtError: reportReactError,
  onRecoverableError: reportReactError,
} satisfies HydrationOptions;
